import { upperFirst } from 'lodash'
import React from 'react'

import { VehicleStateEnum } from 'src/api/provider-agency'
import { DatasetCategory } from 'src/commons/chartjs'
import ComparisonPlot from 'src/commons/graphs/ComparisonPlot'
import Histogram from 'src/commons/graphs/Histogram'
import LinePlot from 'src/commons/graphs/LinePlot'
import TemporalStackedHistogram from 'src/commons/graphs/TemporalStackedHistogram'
import { getTranslation } from 'src/commons/i18n'
import { enumsTranslationKeys } from 'src/commons/i18nEnums'
import { IGraphBucketList, IGraphBucketResponse, IGraphCompare, IGraphData, IGraphStack } from 'src/commons/types'
import HorizontalHistogram from 'src/pages/EmailReport/Graphs/HorizontalHistogram'

export function DeviceDeployedPerProvider(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}
export function AverageFleetSizePerProvider(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      showAverage={false}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function AverageFleetSizePerProviderOnRange(props: IGraphBucketList) {
  return <Histogram title={props.title} rawData={props.graphReport} enableAnimation={props.enableAnimation} />
}
export function PercentDeviceDeployedPerZone(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      formatWithUnit={(amount: string) => `${amount}%`}
      showAverage={false}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function PercentDeviceDeployedPerZonePerProvider(props: IGraphCompare) {
  return (
    <ComparisonPlot
      title={props.title}
      rawData={props.graphReport}
      showAverage={false}
      formatWithUnit={(amount: string) => `${amount}%`}
      datasetCategory={DatasetCategory.provider}
      enableAnimation={props.enableAnimation}
    />
  )
}

function getLegendForStatus() {
  const { t } = getTranslation()
  return (status: VehicleStateEnum) => upperFirst(t(enumsTranslationKeys.VehicleStates[status]))
}

const compareWithRemovedLast = (a: { baseLabel: string; label: string }, b: { baseLabel: string; label: string }) => {
  if (a.baseLabel === VehicleStateEnum.removed) {
    return 1
  }
  if (b.baseLabel === VehicleStateEnum.removed) {
    return -1
  }
  return a.label > b.label ? 1 : -1
}

export function DevicesPerStatus(props: IGraphStack) {
  return (
    <TemporalStackedHistogram
      title={props.title}
      rawData={props.graphReport}
      granularity={props.granularity}
      hiddenLabels={['removed']}
      formatLabel={getLegendForStatus()}
      datasetCategory={DatasetCategory.status}
      orderBy={compareWithRemovedLast}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function FleetAvailability(props: IGraphBucketResponse) {
  if (!props.graphReport) {
    return null
  }

  return (
    <LinePlot
      title={props.title}
      label={''}
      rawData={props.graphReport}
      formatWithUnit={(amount: string) => `${amount}%`}
      granularity={props.granularity}
      displayLegend={false}
      enableAnimation={props.enableAnimation}
    />
  )
}

export function AverageDeploymentDurationPerZone(props: IGraphData) {
  return (
    <HorizontalHistogram
      title={props.title}
      labels={props.graphReport.labels}
      datasets={props.graphReport.datasets}
      displayLegend={false}
      enableAnimation={props.enableAnimation}
    />
  )
}
